// removed by extract-text-webpack-plugin
module.exports = {"SvgElement":"SvgElement__SvgElement__CvuYZ","g-axis-y":"SvgElement__g-axis-y__2hSnw","g-axis-x":"SvgElement__g-axis-x__15ci5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/D3Plot/SvgElement/SvgElement.css
// module id = 303
// module chunks = 0